import { DesignerHeaderProps } from './Types'
import { observer } from 'mobx-react-lite'
import { Header } from './Header'
import { TopBar } from 'components/Design/TopBar/TopBar'
import { Toolbar } from 'components/VisualStudioPlayground/Toolbar/Toolbar'
import { useRootStore } from 'stores/RootStore'
import Styles from './DesignerHeader.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileDesignerHeader } from './MobileDesignerHeader'
import { useAbility } from '@casl/react'
import { AbilityContext } from 'components/Can'
import { useWorkspace } from 'hooks/useWorkspace'
import { useAuth } from 'hooks/UseAuth'
import { SubjectType } from 'utils/caslAbility'
import { getUserRole } from 'utils/workspaceUtils'

const DesignerHeader = observer(({ fileId }: DesignerHeaderProps) => {
  const { designStore, files } = useRootStore()
  const ability = useAbility(AbilityContext)
  const auth = useAuth()
  const file = files.get(fileId)
  const workspace = useWorkspace(file?.workspace.id ?? null)

  const editor = designStore?.editor

  const authedFile = {
    role: getUserRole(workspace, auth),
    version_control_mode: file?.workspace.version_control_mode,
    permissions: file?.permissions,
    isAssociatedAdPublished: !!file?.is_related_ad_published,
    __caslSubjectType__: SubjectType.DESIGN,
  }

  const canEdit = ability.can('edit', authedFile)

  return (
    <div onClick={() => designStore?.editor.updateInstanceState({ isFocused: true })}>
      <Header data-testid="designer-header" className={Styles.header}>
        <TopBar fileId={fileId} canEdit={canEdit} />
        {editor && <Toolbar editor={editor} />}
      </Header>
    </div>
  )
})

const DesignerHeaderContainer = (props: DesignerHeaderProps) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileDesignerHeader {...props} /> : <DesignerHeader {...props} />
}

export { DesignerHeaderContainer as DesignerHeader }
